module.exports = __webpack_public_path__ + "static/img/team-build-3.9d73306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/team-build-3.png
// module id = n/dx
// module chunks = 1